import { render, staticRenderFns } from "./menu-version-list.vue?vue&type=template&id=674904e2&scoped=true"
import script from "./menu-version-list.vue?vue&type=script&lang=js"
export * from "./menu-version-list.vue?vue&type=script&lang=js"
import style0 from "./menu-version-list.vue?vue&type=style&index=0&id=674904e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674904e2",
  null
  
)

export default component.exports